import React from 'react';
import Icon from '../../../components/appIcon';

const AttendanceStats = ({ stats }) => {
  const getStreakIcon = (streak) => {
    if (streak >= 30) return { icon: 'Trophy', color: 'text-yellow-500' };
    if (streak >= 14) return { icon: 'Award', color: 'text-blue-500' };
    if (streak >= 7) return { icon: 'Target', color: 'text-green-500' };
    return { icon: 'Calendar', color: 'text-muted-foreground' };
  };

  const streakInfo = getStreakIcon(stats?.currentStreak);

  return (
    <div className="bg-card border border-border rounded-lg p-6 enterprise-shadow-card">
      <h3 className="text-lg font-semibold text-foreground mb-6">Monthly Summary</h3>
      <div className="space-y-6">
        {/* Attendance Percentage */}
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Attendance Rate</span>
            <span className="text-sm font-medium text-foreground">{stats?.attendancePercentage}%</span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div
              className={`h-2 rounded-full transition-all duration-300 ${
                stats?.attendancePercentage >= 95 ? 'bg-success' :
                stats?.attendancePercentage >= 85 ? 'bg-warning' : 'bg-error'
              }`}
              style={{ width: `${stats?.attendancePercentage}%` }}
            ></div>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center space-x-2 mb-2">
              <Icon name="CheckCircle" size={16} className="text-success" />
              <span className="text-xs text-muted-foreground">Present</span>
            </div>
            <p className="text-xl font-semibold text-foreground">{stats?.presentDays}</p>
          </div>

          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center space-x-2 mb-2">
              <Icon name="XCircle" size={16} className="text-error" />
              <span className="text-xs text-muted-foreground">Absent</span>
            </div>
            <p className="text-xl font-semibold text-foreground">{stats?.absentDays}</p>
          </div>

          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center space-x-2 mb-2">
              <Icon name="Clock" size={16} className="text-warning" />
              <span className="text-xs text-muted-foreground">Late</span>
            </div>
            <p className="text-xl font-semibold text-foreground">{stats?.lateDays}</p>
          </div>

          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center space-x-2 mb-2">
              <Icon name="Timer" size={16} className="text-primary" />
              <span className="text-xs text-muted-foreground">Hours</span>
            </div>
            <p className="text-xl font-semibold text-foreground">{stats?.totalHours}</p>
          </div>
        </div>

        {/* Current Streak */}
        <div className="bg-gradient-to-r from-primary/10 to-accent/10 rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
              <Icon name={streakInfo?.icon} size={20} className={streakInfo?.color} />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Current Streak</p>
              <p className="text-lg font-semibold text-foreground">
                {stats?.currentStreak} {stats?.currentStreak === 1 ? 'day' : 'days'}
              </p>
            </div>
          </div>
          {stats?.currentStreak >= 7 && (
            <div className="mt-3 text-xs text-muted-foreground">
              🎉 Great job! Keep up the excellent attendance!
            </div>
          )}
        </div>

        {/* Best Streak */}
        <div className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
          <div className="flex items-center space-x-2">
            <Icon name="Award" size={16} className="text-yellow-500" />
            <span className="text-sm text-muted-foreground">Best Streak</span>
          </div>
          <span className="text-sm font-medium text-foreground">
            {stats?.bestStreak} {stats?.bestStreak === 1 ? 'day' : 'days'}
          </span>
        </div>

        {/* Average Hours */}
        <div className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
          <div className="flex items-center space-x-2">
            <Icon name="BarChart3" size={16} className="text-blue-500" />
            <span className="text-sm text-muted-foreground">Avg. Daily Hours</span>
          </div>
          <span className="text-sm font-medium text-foreground">{stats?.averageHours}</span>
        </div>

        {/* This Month Progress */}
        <div className="pt-4 border-t border-border">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">This Month</span>
            <span className="text-xs text-muted-foreground">
              {stats?.workingDaysCompleted}/{stats?.totalWorkingDays} days
            </span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div
              className="h-2 bg-primary rounded-full transition-all duration-300"
              style={{ width: `${(stats?.workingDaysCompleted / stats?.totalWorkingDays) * 100}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceStats;